/* eslint-disable import/prefer-default-export */

import {
  VIEW_QUIZ__GET_QUIZ,
  VIEW_QUIZ__GET_QUIZ_SUCCESS,
  VIEW_QUIZ__GET_QUIZ_FAIL,
  START_QUIZ__GET_QUIZ,
  START_QUIZ__GET_QUIZ_SUCCESS,
  START_QUIZ__GET_QUIZ_FAIL,
  RESET_QUIZ,
} from '../constants';
import { buildQuery } from '../helpers';

export function getQuiz(id, params = {}) {
  const query = {
    ...params,
    includeArchived: true,
  };
  return {
    types: [
      VIEW_QUIZ__GET_QUIZ,
      VIEW_QUIZ__GET_QUIZ_SUCCESS,
      VIEW_QUIZ__GET_QUIZ_FAIL,
    ],
    promise: fetch =>
      fetch(`/api/quizzes/${id}/view-quiz?${buildQuery(query)}`, {
        method: 'GET',
      }),
  };
}

export function startQuiz(quizId, params = {}) {
  const query = {
    ...params,
    includeArchived: true,
  };
  return {
    types: [
      START_QUIZ__GET_QUIZ,
      START_QUIZ__GET_QUIZ_SUCCESS,
      START_QUIZ__GET_QUIZ_FAIL,
    ],
    promise: fetch =>
      fetch(`/api/quizzes/${quizId}/start-quiz?${buildQuery(query)}`, {
        method: 'GET',
      }),
  };
}

export function resetQuiz() {
  return {
    type: RESET_QUIZ,
  };
}
